module.exports = __webpack_public_path__ + "img/hr-heatex-W-idle.79eef764.png";